import { createFileRoute } from '@tanstack/react-router';

import { BookingConfirmationPage } from '@/features/bookingConfirmation/BookingConfirmationPage';

export const Route = createFileRoute(
	'/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/primary/confirmation',
)({
	component: RouteComponent,
});

function RouteComponent() {
	const { missionId } = Route.useParams();
	return <BookingConfirmationPage missionId={missionId} variant="prebooking" />;
}
